var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('Button',{staticClass:"search-btn",attrs:{"type":"primary","icon":"ios-search"}},[_vm._v("搜索")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }